<template>
    <div class="forex-index">
        <page-navigate></page-navigate>

        <div class="forex-wrapper cn">
            <forexMenu />
            <div class="forex-wrapper-body">
                <div class="ebc-tabs no-scrollbar">
                    <a href="javascript:;" class="ebc-tab-line-item ebc-tab-line-item-selected">
                        交易大师
                    </a>
                    <a href="/jinrong/shuji/" class="ebc-tab-line-item">
                        交易书籍
                    </a>
                </div>
                <section class="section1">
                    <h1 class="">EBC合作大师</h1>

                    <div class="swiper expert-list-wrapper">
                        <div class="swiper-wrapper expert-list">
                            <div class="swiper-slide" v-for="expert in ebc_master" :key="expert.id">
                                <div class="expert-item">
                                    <a :href="expert.url.replace('/zh-cn', '')" class="img-box">
                                        <img class="expert-item-img" :src="expert.thumbnail"
                                            :alt="expert.post_short_title" />
                                    </a>
                                    <div class="expert-item-content">
                                        <a :href="expert.url.replace('/zh-cn', '')" class="expert-item-name">{{
                                            expert.post_short_title }}</a>
                                        <div class="expert-item-intro">{{ expert.post_excerpt }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section2">
                    <h2 class="">全球交易大师</h2>
                    <div class="swiper expert-global-list-wrapper">
                        <div class="swiper-wrapper expert-list">
                            <div class="swiper-slide" v-for="expert in global_master" :key="expert.id">
                                <div class="expert-item">
                                    <a :href="expert.url.replace('/zh-cn', '')" class="img-box">
                                        <img class="expert-item-img" :src="expert.thumbnail"
                                            :alt="expert.post_short_title" />
                                    </a>
                                    <div class="expert-item-content">
                                        <a :href="expert.url.replace('/zh-cn', '')" class="expert-item-name">{{
                                            expert.post_short_title }}</a>
                                        <div class="expert-item-intro">{{ expert.post_excerpt }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        </div>

        <page-footer></page-footer>
    </div>
</template>
<script>
import 'swiper/css/swiper.css'
import Swiper from 'swiper'
import forexMenu from '../../components/forex-menu/forex-menu.vue';
import { getAcademyExpert } from '../../serve/forex.js';

let swiper1 = null;
let swiper2 = null;
function initSwiper() {
    if (window.innerWidth < 996) {
        if (!swiper1) {
            swiper1 = new Swiper(".expert-list-wrapper", {
                slidesPerView: 3,
                spaceBetween: 40,
                observer: true,
                observeParents: true,

                breakpoints: {
                    // 当容器宽度 <= 996px 时
                    0: {
                        // 这里定义了最小断点，覆盖所有小尺寸
                        slidesPerView: 2.4,
                        spaceBetween: 40,
                    },
                    997: {
                        // 当容器宽度 >= 997px 时恢复默认设置
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                },
            });
        }
        if (!swiper2) {
            swiper2 = new Swiper(".expert-global-list-wrapper", {
                slidesPerView: 3,
                spaceBetween: 40,
                observer: true,
                observeParents: true,

                breakpoints: {
                    // 当容器宽度 <= 996px 时
                    0: {
                        // 这里定义了最小断点，覆盖所有小尺寸
                        slidesPerView: 2.4,
                        spaceBetween: 40,
                    },
                    997: {
                        // 当容器宽度 >= 997px 时恢复默认设置
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                },
            });
        }
    } else if (window.innerWidth >= 996) {
        if (swiper1) {
            swiper1.destroy(true, true); // 销毁 Swiper 实例
            swiper1 = null;
        }
        if (swiper2) {
            swiper2.destroy(true, true); // 销毁 Swiper 实例
            swiper2 = null;
        }
    }
}

// 节流函数
function throttle(fn, delay) {
    let ticking = false;
    return function () {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                fn.apply(this, arguments);
                ticking = false;
            });
            ticking = true;
        }
    };
}




export default {
    components: {
        forexMenu,
        
    },
    data() {
        return {
            expertList: [],
            ebc_master: [],
            global_master: [],
        }
    },
    created() {
        getAcademyExpert().then(response => {
            if (response.status && response.status == '200') {
                this.ebc_master = response.data.data.ebc_master
                this.global_master = response.data.data.global_master
            }

        }).catch(err => {
            this.ebc_master = []
            this.global_master = []
        })
    },
    mounted() {
        // 初始化
        initSwiper();
        // 添加带节流的 resize 监听
        window.addEventListener("resize", throttle(initSwiper, 200));

    }
}
</script>

<style>
    body{
        font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
    }
</style>
<style scoped>
@import url("../../assets/css/forex/rem.css");
@import url("../../assets/css/forex/common.css");
@import url("../../assets/css/forex/forex-tool.css");

.forex-index {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
}

.swiper-container {
    overflow: hidden;
}

section+section {
    margin-top: 88rem;
}

.section1 {
    margin-top: 40rem;
}

.expert-global-list-wrapper,
.expert-list-wrapper {
    margin-top: 48rem;
}

.expert-list {
    display: flex;
    flex-wrap: wrap;
    gap: 56rem 32rem;
}

.expert-list .swiper-slide {
    /* display: block; */
    width: calc(25% - 24rem);
}

.expert-item {}

.img-box {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 285rem;
    border-radius: 46rem;
    overflow: hidden;
}

.img-box::before {
    position: absolute;
    left: 0;
    bottom: 0;
    content: "";
    width: 100%;
    height: 210rem;
    background-color: #f9f6f2;
    border-radius: 46rem 50% 46rem 46rem;
    z-index: -1;
    transition: all 0.47s;
}

.img-box::after {
    position: absolute;
    right: 0;
    top: 50rem;
    font-family: "iconfont" !important;
    content: "\e616";
    font-size: 40rem;
    z-index: -1;
    transition: all 0.47s;
    color: #f9f6f2;
}

.expert-item-img {
    height: 100%;
    width: auto;
    object-fit: cover;
}

.expert-item:hover .img-box::before {
    background-color: #e6ddcf;
    /* height: 240rem; */
}

.expert-item:hover .img-box::after {
    color: #a52933;
    transform: rotateY(180deg);
}

.expert-item-content {
    margin-top: 32rem;
}

.expert-item-name {
    display: block;
    color: #232222;
    font-size: 20rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    white-space: nowrap;
    /* 禁止换行 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    text-overflow: ellipsis;
    /* 溢出时显示省略号 */
}

.expert-item-name:hover {
    color: #232222;
}

.expert-item-intro {
    margin-top: 7rem;
    color: #6a6967;
    font-family: "Source Han Sans CN";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: -webkit-box;
    /* 关键：使用弹性盒模型 */
    -webkit-box-orient: vertical;
    /* 垂直方向排列 */
    -webkit-line-clamp: 1;
    /* 限制显示2行 */
    overflow: hidden;
    /* 隐藏超出部分 */
    text-overflow: ellipsis;
    /* 超出显示... */
}

.expert-btn-text {
    margin-top: 16rem;
    display: inline-block;
    margin-top: 5rem;
    color: #b2afad;
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.expert-btn-text::after {
    font-family: "iconfont" !important;
    content: "\e624";
    color: #b2afad;
    font-size: 14rem;
    margin-left: 4rem;
    line-height: normal;
}

.expert-item:hover .expert-btn-text::after,
.expert-item:hover .expert-btn-text {
    color: #a52933;
}

@media (max-width: 996px) {
    .img-box {
        height: 300rem;
    }

    .img-box::before {
        height: 210rem;
    }

    .expert-list {
        flex-wrap: nowrap;
        gap: 0;
        flex-direction: row;
    }

    .expert-item:hover .img-box::before {
        height: 224rem;
    }

    .expert-item-name {
        font-size: 32rem;
    }

    .expert-item-intro {
        font-size: 28rem;
    }

    .expert-btn-text {
        margin-top: 28rem;
    }

    .expert-btn-text::after,
    .expert-btn-text {
        font-size: 28rem;
    }

}
</style>